module.exports = __webpack_public_path__ + "static/media/lifeOccurrences.97ff56ec.jpg";